import { useState, useEffect } from "react"
import "./Leadership.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "./Header";
import Footer from "./Footer";
const Leadership = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0);   // scroll to top
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <>
            <Header />
            <section className="mobile-tech-hero">
                <div className="hero-background"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="content-container">
                    <div className="hero-content">
                        <div className="identifier-mini" data-aos="fade-down">
                            <i className="fa-regular fa-message"></i> O'HANLONIP · MOBILE MARKETING TECHNOLOGY
                        </div>
                        <h1 className="hero-title" data-aos="fade-up">How Can You<br />Reach Your Customers?</h1>
                        <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="100">O’HanlonIP, LLC, provides a Mobile Marketing Suite of Tools that are effective in reaching your market.</p>
                    </div>
                </div>
            </section>
            {/* <!-- main content card with all descriptions / patents --> */}
            <div className="content-container">
                <div className="patent-card" data-aos="fade-up">

                    {/* <!-- core message repeated from prompt --> */}
                    <div style={{ marginBottom: "2rem" }} data-aos="fade-right">
                        <p style={{ fontSize: "1.2rem", color: "#1D3A90", fontWeight: "500" }}><i className="fa-regular fa-building" style={{ marginRight: "10px" }}></i> O’HanlonIP, LLC, is a Mobile Marketing Technology Company</p>
                        <p>We provide a turnkey Software as a Service text messaging platform to the Mobile Text Message Marketing Industry. Our tool possesses most all modern day features that are compulsory for a Marketing Team to reach your customers.</p>
                    </div>

                    {/* <!-- Tools / platforms (MOTOM / MOEOM) in grid (inspired by team cards but repurposed) --> */}
                    <div className="tools-grid">
                        <div className="tool-item" data-aos="fade-up">
                            <div className="tool-icon"><i className="fa-regular fa-comment-dots"></i></div>
                            <h4>MOTOM™</h4>
                            <p>Mobile Originated Text Opt‑in / Opt‑out Messaging. TCPA‑compliant, seamless subscriber management.</p>
                        </div>
                        <div className="tool-item" data-aos="fade-up" data-aos-delay="50">
                            <div className="tool-icon"><i className="fa-regular fa-envelope"></i></div>
                            <h4>MOEOM™</h4>
                            <p>Mobile Originated Email Opt‑in / Opt‑out. Integrated email-to-SMS/MMS workflows.</p>
                        </div>
                        <div className="tool-item" data-aos="fade-up" data-aos-delay="100">
                            <div className="tool-icon"><i className="fa-regular fa-comment-dots"></i></div>
                            <h4>Real‑time rich media</h4>
                            <p>Push pictures, audio, video to any device using patented O’Hanlon real‑time delivery.</p>
                        </div>
                    </div>

                    {/* <!-- US company + licensee mention --> */}
                    <div
                        style={{
                            background: "#eef4fe",
                            borderRadius: "50px",
                            padding: "1.8rem 2.2rem",
                            margin: "2.5rem 0",
                        }}
                        data-aos="fade-up"
                    >
                        <p><i className="fa-regular fa-check-circle" style={{
                            color: "#1D3A90",
                            fontSize: "1.6rem",
                            marginRight: "15px",
                            verticalAlign: "middle",
                        }}></i> <span style={{ fontWeight: "600" }}>O’HanlonIP, LLC, is a US Company</span> that controls powerful and far reaching intellectual property impacting the text notification industry. As an SMS/MMS Service Provider, our platforms driven by patented technology allow businesses to send TCPA Compliant Text Messages to their clients.</p>
                        <p style={{
                            marginTop: "1rem",
                            background: "white",
                            padding: "0.8rem 1.5rem",
                            borderRadius: "40px",
                        }}><i className="fa-regular fa-check-circle" style={{ color: "#54A6E9" }}></i> The original parent company for O’HanlonIP, LLC, is a licensee of O’HanlonIP, LLC. Founded in 2005, O’HanlonIP, LLC owns all rights to the following patents:</p>
                    </div>

                    {/* <!-- Patent list (exact descriptions from prompt) --> */}
                    <div className="patent-list" data-aos="fade-up">
                        {/* <!-- patent 1 --> */}
                        <div className="patent-entry">
                            <span className="patent-number">US Patent #7,643,821 (the '821 patent)</span>
                            <div className="patent-description"><i className="fa-regular fa-check-circle"></i> The patent that solved the technological shortcomings of the state of the art, thereby enabling advertisers to push rich digital content (e.g., pictures, audio, and video) to mobile devices in real-time. The patented technology enabled the mobile ad industry to become what it is today.</div>
                        </div>
                        {/* <!-- patent 2 --> */}
                        <div className="patent-entry">
                            <span className="patent-number">US Patent #8,437,453 B2 (the '453 patent)</span>
                            <div className="patent-description"><i className="fa-regular fa-check-circle"></i> Solved the problem of rigid and technically complex IVR setups by providing a flexible, distributed platform that allows businesses to efficiently route calls based on caller-specific identifiers like DNIS, ANI, or item IDs. It eliminates reliance on centralized systems, enabling businesses to independently manage and update IVR configurations, ensuring quick adaptability and improved customer experience.</div>
                        </div>
                        {/* <!-- patent 3 --> */}
                        <div className="patent-entry">
                            <span className="patent-number">US Patent #9,038,887 B1 (the '887 patent)</span>
                            <div className="patent-description"><i className="fa-regular fa-check-circle"></i> Solved the problem of inefficient interaction between physical/digital items and telephone devices by enabling multi‑function codes (QR codes, barcodes) to open multiple communication channels, including obtaining the telephone number of the scanning device. Streamlines lead generation and follow‑up by automatically capturing and forwarding leads to agents via text or email, with fallback mechanisms and item‑specific information delivery.</div>
                        </div>
                        {/* <!-- patent 4 --> */}
                        <div className="patent-entry">
                            <span className="patent-number">US patent #8,817,959 B1 (the '959 patent)</span>
                            <div className="patent-description"><i className="fa-regular fa-check-circle"></i> Addressed inefficient tracking, distribution, and management of customer interactions and leads. By enabling subscribers to create customized landing and flyer web pages, the system facilitates seamless information sharing. It resolves lead generation challenges by automatically recording interactions (page views, link clicks) and presenting actionable reports, enhancing marketing effectiveness and customer responsiveness.</div>
                        </div>
                        {/* <!-- patent 5 --> */}
                        <div className="patent-entry">
                            <span className="patent-number">US Patent #8,774,371 B1 (the '371 patent)</span>
                            <div className="patent-description"><i className="fa-regular fa-check-circle"></i> Solved the problem of rigid and centralized IVR setups that are difficult to customize and scale. This distributed IVR system enables flexible call routing based on DNIS, ANI, or item ID. By storing IVR strings on an index computer or external servers and giving businesses direct access to manage configurations without technical expertise, it enhances efficiency, scalability, and adaptability while reducing overhead.</div>
                        </div>
                    </div>

                    {/* <!-- bottom action / contact (similar style) --> */}
                    <hr style={{ margin: "3rem 0", border: "1px solid #d6e3f5" }} />
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "2rem",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <a href="/contact" className="btn btn-primary"><i className="fa-regular fa-calendar"></i> Schedule a platform demo</a>
                        <span className="company-tagline"><i className="fa-regular fa-message" style={{ color: "#1D3A90" }}></i> 80% AI · 100% TCPA compliant</span>
                    </div>
                    <p style={{ textAlign: "center", marginTop: "2rem", color: "#5e79a6" }}><i className="fa-regular fa-copyright"></i> O’HanlonIP, LLC – Mobile marketing suite & patented technologies</p>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Leadership;